const unverifiedUser = {
  notVerified: 'Ihr Kundenkonto wurde noch nicht verifiziert. Bitte verifizieren Sie Ihren Account, indem Sie auf den Link in der E-Mail klicken, die wir Ihnen gesendet haben.',
  resendEmail: 'E-Mail erneut senden',

  modal: {
    title: 'Ihr Kundenkonto wurde noch nicht verifiziert.',
    description: 'Bitte verifizieren Sie Ihren Account, indem Sie auf den Link in der E-Mail klicken, die wir Ihnen nach Ihrer Registrierung zugesendet haben. Im Anschluss können Sie sich mit Ihren Nutzerdaten anmelden. Prüfen Sie im Zweifel auch den Spam-Ordner.',
  },
  resendPage: {
    title: 'Keine Verifizierungs-E-Mail erhalten?',
    content: 'Wenn Sie keine E-Mail erhalten haben, um Ihr Kundenkonto zu verifizieren, geben Sie bitte Ihre E-Mail-Adresse ein, damit wir Ihnen die Verifizierungs-E-Mail erneut zusenden können.',
    yourEmail: 'Ihre E-Mail-Adresse',
    incorrectEmail: 'Falls die E-Mail-Adresse nicht korrekt ist, können Sie diese selbstverständlich ändern.',
    sendRequest: 'Erneut senden',
    changeEmail: 'E-Mail ändern',
    emailChanged: 'Sie haben die Änderung Ihrer E-Mail-Adresse auf <b>{email}</b> beantragt. Bitte überprüfen Sie Ihren E-Mail-Posteingang auf eine Bestätigungs-E-Mail, um die Änderung und die Verifizierung des Kontos abzuschließen.',
  },
}

export default unverifiedUser
